<div class="map-list">
  @if (path !== 'playlist') {
    <button
      class="all-filters-btn"
      [ngClass]="{ active: numberOfActiveFilters }"
      (click)="onDisplayFilters()">
      <span class="icon icon-new-filter"></span>
      <span class="filter-label">{{ 'browse.map.filters' | translate }}</span>
      <span
        class="icon"
        [ngClass]="{
          'icon-slide-arrow': !isSelectingFilters,
          'icon-fleche': isSelectingFilters,
        }"></span>
      @if (numberOfActiveFilters) {
        <span class="badge">{{ numberOfActiveFilters }}</span>
      }
    </button>
  }
  <div class="cards-container" #cardsContainer>
    @if (isPotentialContentAvailable) {
      <ng-container>
        @if (isLargeScreen) {
          <ng-container>
            @for (video of videos; track $index) {
              <ng-container
                [ngTemplateOutlet]="card"
                [ngTemplateOutletContext]="{ video: video }" />
            }
            @if (isLoading) {
              <div class="card-container">
                <app-loader />
              </div>
            }
          </ng-container>
        } @else {
          <kin-horizontal-scroller #carousel [activeItemId]="selectedVideo?.id">
            @for (video of videos; track $index) {
              <ng-container
                [ngTemplateOutlet]="card"
                [ngTemplateOutletContext]="{ video }" />
            }
          </kin-horizontal-scroller>
        }
      </ng-container>
    } @else {
      @if (isLargeScreen) {
        <div class="no-content">
          {{ 'browse.noContentAvailable' | translate }}
        </div>
      }
    }
  </div>
</div>

<ng-template #card let-video="video">
  <kin-scenic-card
    [ngStyle]="{ 'margin-right': isLargeScreen ? '0' : '20px' }"
    [id]="isLargeScreen ? 'mapVideo' + video.id : 'item-' + video.id"
    [animate]="selectedVideo?.id !== video.id || false"
    (mouseenter)="onSelectedOrUnselectedVideo(video.id)"
    (mouseleave)="onSelectedOrUnselectedVideo()"
    [information]="video"
    size="small"
    [condensed]="true"
    (onCardClick)="navigateToVideo(video.id)" />
</ng-template>
